<span
  class="rr-clipboard cursor-pointer copy"
  ngxClipboard
  [cbContent]="data"
  (cbOnSuccess)="showInfo(true)"
  (cbOnError)="showInfo(false)"
  alt="copy to clipboard"
></span>
